import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getSchools = async () => {
  try {
    const response = await axios.get(`${base_url}school`, config);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};

const getaSchool = async (id) => {
  const response = await axios.get(`${base_url}school/${id}`, config);

  return response.data;
};
const getSchoolVisitData = async (id) => {
  const response = await axios.get(`${base_url}schoolVisist/vc/${id}`, config);

  return response.data;
};

const createSchool = async (schools) => {
  const response = await axios.post(`${base_url}school`, schools, config);
  return response.data;
};

//new endpoint
const getSchoolVisitList = async () => {
  const response = await axios.get(`${base_url}school/visit/plan`, config);
  return response.data;
};

//new endpoint
const getSchoolVisitTarget = async () => {
  const response = await axios.get(`${base_url}schoolVisist`, config);
  return response.data;
};

const getSchoolVisitStatus = async () => {
  const response = await axios.get(
    `${base_url}school/school-visit-plan/status/completed-pending`,
    config
  );
  return response.data;
};

const schoolService = {
  getSchools,
  getaSchool,
  createSchool,
  getSchoolVisitList,
  getSchoolVisitTarget,
  getSchoolVisitStatus,
  getSchoolVisitData,
};

export default schoolService;
